<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media">
      <img
        class="b-r-10"
        :src="userData.profile_img ? $image_url + userData.profile_img : require('@/assets/images/dashboard/no-user.jpg')"
        alt="Profile"
        style="width: 40px; height: 40px; object-fit: cover; border-radius: 50%;"
      />
      <div class="media-body" style="margin-top: 6px;">
        <span class="profile-name">{{ userData.name }}<i class="middle fa fa-angle-down"></i></span>
        <!-- <p class="mb-0 font-roboto">
          Admin <i class="middle fa fa-angle-down"></i>
        </p> -->
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div" style="width: 400px;">
     
      <!-- <li>
        <i class="fa fa-gear"></i> <router-link :to="{ name: 'settings' }">Settings</router-link>
      </li> -->
      <li>
        <a @click="logout"
          ><vue-feather type="log-in"></vue-feather><span>Log out</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script>

  export default {
    name: 'Profile',

    data() {
			return {
        userData: {},
      };
		},

    created() {
			this.fetchSettings();
		},
    methods: {

      getToken() {
        if (localStorage.getItem('trazio')) {
          var trazio =  JSON.parse(localStorage.getItem('trazio'));
          if(trazio.token) {

            this.token = trazio.token;
            this.user = trazio;
            console.log(this.user);
          } else {
            this.$swal("", "Failed to fetch token, please login again", "error");
            this.$router.push({ name: "login" });
          }

        } else {
          this.$swal("", "Session expired, please login again", "error");
          this.$router.push({ name: "login" });
        }
      },

      fetchSettings(page_url = null) {
				this.getToken();
				let url = "/trazio/settings";
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.userData = responseData.admin;
            console.log(this.userData);
						
					})
					.catch((err) => console.log(err));
			},

      logout() {
        let url = "api/logout";         
        this.getToken();
        this.loading = true;
        this.$axios
        .get(url, { headers: { Authorization: "Bearer " + this.token } })
        .then((res) => {
          console.log(res);
          var responseData = res.data.data;
          console.log(responseData);

          if(localStorage.getItem('trazio')) {
            localStorage.removeItem("trazio");    
          }         
          this.$swal("", "You have been successfully logged out", "success");
          this.$router.push({ name: "login" });
        })
        .catch((error) => {
          if (error.response) {
            if(error.response.status == 422) {               
              if (error.response.data) {
                this.errors = error.response.data.message;
              } 
              this.$swal("", error.response.statusText, "error");
                        
            } else if(error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
                        
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        })
        .finally(() => (this.loading = false));
      },
    },
  };
</script>
